import { damp, clamp, transform } from '@studiometa/js-toolkit/utils';
import { LargeText as LargeTextCore } from '@studiometa/ui';

/* eslint-disable */

/**
 * Class LargeText.
 * @extends LargeTextCore
 * @class
 */
export default class LargeText extends LargeTextCore {
  static config = {
    name: 'LargeText',
    options: {
      ...LargeTextCore.config.options,
    },
  };

  isHover = false;
  isTextActivate = false;

  /**
   * Bind events.
   */
  onTargetMouseenter() {
    this.isHover = true;
  }

  /**
   * Bind events.
   */
  onTargetMouseleave() {
    this.isHover = false;
  }

  /**
   * Toggle text color on click.
   */
  onTargetClick() {
    if (!this.isTextActivate) this.animate = true;

    this.isTextWhite = !this.isTextWhite;
    this.isTextActivate = !this.isTextActivate;
  }

  /**
   * Update delta scroll on scroll.
   * @returns {this}
   */
  scrolled() {
    return this;
  }

  /**
   * Update delta scroll on scroll.
   * @returns {this}
   */
  // @ts-ignore
  ticked() {
    if (this.isHover || this.isTextActivate || this.animate) {
      this.x -= (Math.abs(this.deltaY) + 2) * this.$options.sensitivity;

      this.transform.x = damp(this.x, this.transform.x, 0.25);

      if (this.$options.skew) {
        this.transform.skewX = damp(
          clamp(this.deltaY * -1, -50, 50) * this.$options.skewSensitivity,
          this.transform.skewX,
          0.25
        );
      }

      if (this.x <= this.width * -1) {
        this.x = 0;
        this.transform.x += this.width;
      } else if (this.$options.sensitivity < 0 && this.x >= this.width) {
        this.x = 0;
        this.transform.x -= this.width;
      }

      // @ts-ignore
      return () => {
        transform(this.$refs.target, this.transform);
      };
    }
  }
}
